(ns hai.mini-apps.table
  "Mini-apps table"
  #?(:cljs (:require-macros hai.mini-apps.table))
  #?(:cljs
     (:require
      [clojure.string :as str]
      [hai-model.model :as model]
      [hai.sharing.components :as sharing.components]
      [hai.mini-apps.card :as card]
      [hai.mini-apps.common :as common]
      [hai.ui.components :as c]
      [hai.ui.components.collection.bulk-actions :as bulk-actions]
      [hai.ui.components.collection.filters :as filters]
      [hai.ui.components.collection.table :as collection]
      [hai.ui.components.collection.views.table :as table]
      [hai.ui.components.form.select.single-select :as single-select]
      [hai.ui.icons :as icons]
      [hai.ui.rf-sugar :refer [>e]]
      [hai.web-app.routing :as routing]
      [malli.util :as mu])))

(defn mini-apps-table
  [_]
  #?(:cljs
     [collection/component
      {:id ::table
       :collection.view/default :collection.view/cards
       :query [{:mini-apps/table
                [{:collection/items
                  [:mini-app/uuid
                   :mini-app/title
                   :mini-app/tool
                   :mini-app/active?
                   :mini-app/beta?
                   :mini-app/source-url
                   :user.entity/permissions
                   sharing.components/shared-with-query]}]}]
       :schema (mu/select-keys model/MiniApp
                               [:mini-app/uuid
                                :mini-app/title
                                :mini-app/active?
                                :mini-app/beta?])
       :update-mutation 'mini-app/update
       :paginate? true
       :no-items (fn [_] [:em "No apps found"])
       :card card/render
       :columns [{:header "Type"
                  :render (fn [{:mini-app/keys [tool]}]
                            [table/table-cell
                             [:div {:style {:display "flex"
                                            :justify-content "center"
                                            :width "100%"}}
                              (if-let [icon (get common/tool->icon tool)]
                                [:div {:style {:width "20px" :height "20px"}}
                                 [icon]]
                                (some-> tool name str/capitalize))]])
                  :attr :mini-app/tool
                  :sort? false
                  :filter {:schema :keyword
                           :type :filter.remote/select
                           :placeholder "Tool..."
                           :field single-select/field}}
                 {:header "Title"
                  :attr :mini-app/title
                  :render (fn [{:mini-app/keys [uuid title]}]
                            [table/table-cell
                             [c/Link
                              {:style {:cursor "pointer"}
                               :href (routing/href :admin-ui/mini-app-edit
                                                   {:mini-app/uuid uuid})}
                              title]])
                  :filter (filters/text-search {:placeholder "Title..."})}
                 {:header ""
                  :attr :mini-app/source-url
                  :sort? false
                  :render (fn [{:mini-app/keys [source-url]}]
                            [table/table-cell
                             (when source-url
                               [c/Link {:href source-url
                                        :target "_blank"}
                                [icons/outlined-open_in_new]])])}
                 ;; Active toggles dispatch immediately rather than using the standard
                 ;; `:field col.form/toggle` + submit/cancel pattern. Going through
                 ;; `:mini-app/fields-update` lets the backend route the write through the
                 ;; per-user preference path for shared (non-owner) users.
                 ;;
                 ;; Switching to the standard submit-on-change pattern is doable but not
                 ;; trivial. The blocker: `submit-edits-button` submits ALL rows on click,
                 ;; not just dirty ones. For owners that's a no-op (backend diffs entity
                 ;; state) but for non-owners every row would get a preference write,
                 ;; silently locking the user into their current view of every mini-app.
                 ;; Fix would be either filtering dirty rows in `submit-edits-button` or
                 ;; diffing against effective state in the non-owner mutation branch.
                 {:header "Active"
                  :attr :mini-app/active?
                  :render-with-collection
                  (fn [collection {:mini-app/keys [uuid active?]}]
                    [table/table-cell
                     [c/Switch
                      {:checked (boolean active?)
                       :on-checked-change
                       (fn [new-value]
                         (>e [:resolve
                              [(list 'mini-app/update
                                     {:mini-app/uuid uuid
                                      :mini-app/fields-update {:mini-app/active? new-value}})]
                              {:on-success-fx [[:dispatch [:table/resolve collection]]
                                               [:browser-ext/notify-mini-apps-changed {:mini-app/uuids [uuid] :change :updated}]]}]))}]])
                  :filter {:schema :keyword
                           :type :filter/select
                           :default :mini-app.active/all
                           :field single-select/field
                           :form.field.select/options [{:value :mini-app.active/active
                                                        :title "Active"}
                                                       {:value :mini-app.active/inactive
                                                        :title "Inactive"}
                                                       {:value :mini-app.active/all
                                                        :title "All"}]}}
                 {:header ""
                  :attr :mini-app/beta?
                  :render (fn [{:mini-app/keys [beta?]}]
                            [table/table-cell
                             (when beta?
                               [c/Badge {:color "purple" :variant "soft"} "Beta"])])}
                 sharing.components/shared-with-column]
       :bulk-actions [{:title "Delete"
                       :disabled? bulk-actions/disabled?
                       :mutation 'mini-app/delete
                       :on-success-fx (fn [selected]
                                       [[:browser-ext/notify-mini-apps-changed
                                         {:mini-app/uuids (mapv :mini-app/uuid selected)
                                          :change        :deleted}]])
                       :alert {:content (fn [{:table/keys [selected] :as table} action]
                                          [bulk-actions/confirm-dialog
                                           {:table  table
                                            :action action}
                                           [bulk-actions/title "Confirm Deletion of Mini-apps"]
                                           [bulk-actions/description "Are you sure you want to delete the following Mini-apps?"]
                                           (into [:ul]
                                                 (map (fn [{:mini-app/keys [title]}]
                                                        [:li [:strong title]]))
                                                 selected)])}}]}]))
